import SchedulingFeed from './SchedulingFeed';

export default SchedulingFeed;
